module.exports = __webpack_public_path__ + "static/img/onlineShopFrame.ee8511b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/onlineShopFrame.png
// module id = Cg4Z
// module chunks = 1